module.exports = __webpack_public_path__ + "img/violet_077.e9fe807e.png";